import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/agency-tools/newlp/FeaturesSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/agency-tools/newlp/Hero.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/app/agency-tools/newlp/styles.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/Footer.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@15.4.11_@babel+core@7.29.0_@opentelemetry+api@1.9.0_react-dom@19.2.4_react@19.2.4__react@19.2.4_sass@1.77.4/node_modules/next/font/google/target.css?{\"path\":\"app/agency-tools/newlp/SectionBadge.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"],\"weight\":[\"400\"]}],\"variableName\":\"inter\"}");
